import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { PersonaService } from "src/app/servicios/persona.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TipoDocumentoService } from "src/app/servicios/tipo-documento.service";
import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import * as _moment from "moment";
import { DireccionService } from "src/app/servicios/direccion.service";
import { UsuarioService } from "src/app/servicios/usuario.service";
import { HelperService } from "src/app/servicios/helper.service";
import { DynamicFormComponent } from "src/app/dynamic-form/dynamic-form.component";
import { EstructuraBase } from "src/app/model-form/estructura-base";
import { SetFormService } from "src/app/servicios/set-form.service";
import { Utils } from "src/app/utils/utils";
import { DepartamentosService } from "src/app/servicios/departamentos.service";
import { CiudadesService } from "src/app/servicios/ciudades.service";

@Component({
  selector: "app-dialog-edit-persona",
  templateUrl: "./dialog-edit-persona.component.html",
  styleUrls: ["./dialog-edit-persona.component.css"],
})
export class DialogEditPersonaComponent implements OnInit {
  /**CREACION DIRECCION */
  @ViewChild("resetForm") resetForm: DynamicFormComponent;
  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 28; //no se debe repetir
  origenParent = "dialogeditpersona"; //no se debe repetir
  parametrosDestino: any[] = [];
  procedimientoDestino: string = "";
  dataModified = false;
  /**FIN CREACION DIRECCION  */

  personaGroup: FormGroup;
  direccionGroup: FormGroup;
  dataModificaDireccion: any;
  dataModificaUsuario: any;
  tipoDocumentosSelect = [];
  loadingPersona = false;
  loadingDetalle = false;
  direcciones = [];
  usuarios = [];
  modificaDireccion = false;
  modificaUsuario = false;
  creaDireccion = false;
  departamentosDireccion = [];
  ciudadesDireccion = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialog,
    private servicePersona: PersonaService,
    private serviceTipoDocumento: TipoDocumentoService,
    private servicioDireccion: DireccionService,
    private servicioUsuario: UsuarioService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private helper: HelperService,
    private servicioFormulario: SetFormService,
    private formatFormulario: Utils,
    private servicioDepartamento: DepartamentosService,
    private servicioCiudad: CiudadesService
  ) {
    /**CREACION DIRECCION */
    this.descripcion = "Creación De Dirección";
    let response: any;

    this.servicioFormulario
      .getFormulario(this.idFormulario)
      .subscribe((data) => {
        this.procedimientoDestino = data[0].procedimientoDestino;
        response = this.formatFormulario.formatFormulario(data);
        this.items = response.arrayDatos;
        this.parametrosDestino = response.parametros;

        return this.items.sort((a, b) => a.order - b.order);
      });
    /**END CREACION DIRECCION */
    this.personaGroup = this.fb.group({
      IdPersona: [""],
      NroDocId: ["", Validators.required],
      IdTpoIdenti: ["", Validators.required],
      Nombre: ["", [Validators.required, Validators.maxLength(250)]],
      Apellido: ["", [Validators.required, Validators.maxLength(250)]],
      FechaNac: ["", Validators.required],
      Telefono: ["", [Validators.maxLength(30)]],
    });

    this.direccionGroup = this.fb.group({
      nombreDireccion: ["", Validators.required],
      telefono: ["", [Validators.required, Validators.maxLength(20)]],
      telefono2: ["", Validators.maxLength(20)],
      departamento: ["", Validators.required],
      ciudad: ["", Validators.required],
      direccion: ["", Validators.required],
      observacion: ["", Validators.maxLength(4000)],
    });
  }

  ngOnInit() {
    console.log(JSON.stringify(this.dataDialog));
    this.loadingDetalle = true;
    this.getPersonaDetalle();
    this.loadingPersona = true;
    this.serviceTipoDocumento.getTiposDocumento().subscribe((result) => {
      this.loadingPersona = false;
      this.tipoDocumentosSelect = result;
      this.personaGroup.controls["IdPersona"].setValue(
        this.dataDialog.IdPersona
      );
      this.personaGroup.controls["NroDocId"].setValue(this.dataDialog.NroDocId);
      this.personaGroup.controls["IdTpoIdenti"].setValue(
        this.dataDialog.IdTpoIdenti
      );
      this.personaGroup.controls["Nombre"].setValue(this.dataDialog.Nombre);
      this.personaGroup.controls["Apellido"].setValue(this.dataDialog.Apellido);
      this.personaGroup.controls["FechaNac"].setValue(this.dataDialog.FechaNac);
      this.personaGroup.controls["Telefono"].setValue(this.dataDialog.Telefono);
    });

    this.servicioDepartamento.getDepartamentos().subscribe((result) => {
      //console.log(result);
      this.departamentosDireccion = result;
    });
  }

  getPersonaDetalle() {
    this.servicePersona
      .getPersonaDetalle(this.dataDialog.IdPersona)
      .subscribe((result) => {
        this.loadingDetalle = false;
        this.direcciones = result[0];
        this.usuarios = result[1];
      });
  }

  /**CREACION DIRECCION */
  dataFormulario($event) {
    const dataForm = $event;
    if (dataForm.parent === this.origenParent) {
      const respuesta = this.validators(dataForm.datos);
    }
  }

  validators(dataForm) {
    //alert('aqui');
    dataForm.infoPayload.push({
      key: "idPersona",
      parametro: "v_IdPersona",
      value: this.dataDialog.IdPersona,
    });

    this.servicioFormulario.postFormulario(dataForm).subscribe((data) => {
      //this.getPersonaDetalle();
      this.snackBar.open("Direccion Agregada", "Crear Dirección", {
        duration: 2000,
      });
      this.reset();
    });
    return true;
  }

  reset() {
    this.resetForm.resetForm();
  }
  /**END CREACION DIRECCION */

  ActualizarPersona() {
    this.dialogRef.closeAll();
  }

  crearDireccion() {
    this.modificaDireccion = false;
    //alert(this.creaDireccion);
    this.creaDireccion = !this.creaDireccion;
    //alert(this.creaDireccion);
  }

  editarDireccion(direccion) {
    //alert(JSON.stringify(direccion));
    this.dataModificaDireccion = direccion;
    this.modificaDireccion = true;
    this.creaDireccion = false;
  }

  eliminarDireccion(direccion) {
    Swal.fire({
      title: "Eliminar Dirección?",
      text: "Esta seguro que desea eliminar esta dirección!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, Eliminar!",
    }).then((result) => {
      if (result.value) {
        this.servicioDireccion
          .deleteDireccion(direccion.IdPersonaDireccion)
          .subscribe((data) => {
            const indexDireccion = this.helper.findIndex(this.direcciones, {
              IdPersContacto: direccion.IdPersContacto,
            });
            this.direcciones.splice(indexDireccion, 1);
            Swal.fire("Eliminado!", "Registro Eliminado.", "success");
          });
      }
    });
  }

  editarUsuario(usuario) {
    //alert(JSON.stringify(direccion));
    this.dataModificaUsuario = usuario;
    this.modificaUsuario = true;
  }

  eliminarUsuario(usuario) {
    Swal.fire({
      title: "Eliminar Usuario?",
      text: "Esta seguro que desea eliminar este usuario!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, Eliminar!",
    }).then((result) => {
      if (result.value) {
        this.servicioUsuario
          .deleteUsuario(usuario.IdUsuario)
          .subscribe((data) => {
            const indexUsuario = this.helper.findIndex(this.usuarios, {
              IdUsuario: usuario.IdUsuario,
            });
            this.usuarios.splice(indexUsuario, 1);
            Swal.fire("Eliminado!", "Registro Eliminado.", "success");
          });
      }
    });
  }

  submitForm() {
    let persona = this.personaGroup.value;
    persona.FechaNac = _moment(persona.FechaNac, "YYYY-MM-DD").format(
      "YYYY-MM-DD"
    );
    persona.Nombre = persona.Nombre.toUpperCase();
    persona.Apellido = persona.Apellido.toUpperCase();
    this.servicePersona.putPersona(persona).subscribe((result) => {
      this.dataModified = true;
      this.snackBar.open("Persona Actualizada", "Actualizar Persona", {
        duration: 2000,
      });
    });
  }

  procesaPropagar(mensaje) {
    //console.log(mensaje);
    this.loadingDetalle = true;
    this.getPersonaDetalle();
  }

  procesaPropagarDireccion(direccion) {
    this.loadingDetalle = true;
    this.getPersonaDetalle();
  }

  getCiudades(event) {
    const depto = event.target.value;
    this.servicioCiudad.getCiudades(depto).subscribe((result) => {
      this.ciudadesDireccion = result;
    });
  }

  resetFormDireccion() {
    this.direccionGroup.controls["nombreDireccion"].setValue("");
    this.direccionGroup.controls["telefono"].setValue("");
    this.direccionGroup.controls["telefono2"].setValue("");
    this.direccionGroup.controls["departamento"].setValue("");
    this.direccionGroup.controls["ciudad"].setValue("");
    this.direccionGroup.controls["direccion"].setValue("");
    this.direccionGroup.controls["observacion"].setValue("");
  }

  nuevaDireccion() {
    let persona = this.direccionGroup.value;
    persona.idPersona = this.dataDialog.IdPersona;
    console.log(JSON.stringify(persona));
    this.servicioDireccion.postDireccion(persona).subscribe((result) => {
      this.loadingDetalle = true;
      this.getPersonaDetalle();
      this.resetFormDireccion();
      this.snackBar.open("Dirección Creada", "Modulo Direccion", {
        duration: 2000,
      });
    });
  }
}
